import EksoGraphContainerWrapper from "components/shared/ui/Graph/EksoGraphContainerWrapper";
import Stats from "models/bluechip/Stats";
import TherapistContentLayout from "./TherapistContentLayout";

export default EksoGraphContainerWrapper(TherapistContentLayout, Stats, {
  resourceTypeName: "stats",
  resourceName: "stats/my_utilization",
  id: "my_utilization",
});
